import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import { AuthProvider } from './lib/auth'
import { EntitlementsProvider } from './lib/entitlements'
import { SkinProvider } from './lib/skin'
import './styles/tokens.css'
import './styles/print.css'

const container = document.getElementById('root')
if (!container) throw new Error('#root missing from index.html')

createRoot(container).render(
  <StrictMode>
    {/* The SPA is served under /app, so the router needs the same basename or
        every internal link resolves one level too high. */}
    <BrowserRouter basename="/app">
      <SkinProvider>
        <AuthProvider>
          {/* Inside AuthProvider: it listens to the signed-in account's
              subscription, so it has to be able to read who that is. */}
          <EntitlementsProvider>
            <App />
          </EntitlementsProvider>
        </AuthProvider>
      </SkinProvider>
    </BrowserRouter>
  </StrictMode>,
)
